import { useState, useEffect } from 'react';
import { getCardBankName, InnocodePaymentCard, InnocodePaymentCardInfo, InnocodePaymentHistoryList, InnocodePaymentListHorizental, } from '@intsoft/innocode-payment';
import { InnocodeBadge, InnocodeButton, InnocodeCheckbox, InnocodeCheckmark, InnocodeInput, InnocodeLoadingSpinner, InnocodePaginationGroup, InnocodeRadiobox, InnocodeTextButton, useDialog, useModal } from '@intsoft/innocode-core';

import { useNavigate } from 'react-router-dom';
import styles from './RequestPay.module.css';
import { PaymentMethod, PaymentType } from '../../../resources/utils/paymentUtils';
import { PasswordChangeModal } from '../../../resources/modal/PasswordChangeModal';
import { RegisterCardModal } from '../../../resources/modal/RegisterCardModal';
import { TermModal } from '../../../resources/modal/TermModal';
import { TERMS } from '../../../resources/constants/terms';
import { getCookie } from '../../../utils/cookies/cookies';
import { IAM_PATH, OAUTH, STORE_ORDER, ZENPAY_BILLING, ZENPAY_PAY_PASSWORD, ZENPAY_PAYMENT } from '../../../utils/Config';
import axios from 'axios';
import { CardType, mapApiBrandToCardType, mapApiIssuerToBankType } from '../../../resources/utils/bank-types';
import { format } from 'date-fns';
import { calculateNextBillingTimestamp, formatBillingPeriod } from '../../../resources/utils/subscriptionUtils';
import { usePasswordChangeModal } from '../../NavBar/component/usePasswordChangeModal';

import type {
  paymentHistoryDetailInfo,
  orderProductInfo,
  ApiCardData,
  cardInfo,
  DiscountDetail,
  DiscountInfo,
  paymentSteps,
  paymentResult,
  OrderRequest,
  PaymentRequest,
  PaymentRequestResult
} from './types';
import moment from 'moment';

export default function RequestPay() {
  const { showInnocodeModal: showBottomModal } = useModal();
  const [platform, setPlatform] = useState<'web' | 'tablet-vertical' | 'mobile'>('web');
  const { showDialog } = useDialog();
  const [step, setStep] = useState<paymentSteps>("PAYMENT");
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>('');
  const { handleOpenModal } = usePasswordChangeModal(userId);

  const getPlatform = (width: number): 'web' | 'tablet-vertical' | 'mobile' => {
    if (width < 768) return 'mobile';
    if (width < 1024) return 'tablet-vertical';
    return 'web';
  };

  const formatCurrency = (amount: any): string => {

    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (numAmount || 0).toLocaleString('ko-KR');
  };

  //요청 정보
  const [requestInfo, setRequestInfo] = useState<any>({});
  //할인 정보
  const [discount, setDiscount] = useState<DiscountInfo>({
    discountRate: 0,
    discountAmount: 0,
    value: []
  });

  //정기 결제 정보
  const [subscriptionInfo, setSubscriptionInfo] = useState<any>({
    nextPaymentDate: "",
    paymentPeriod: "",
  });

  //결제 완료 후 결과
  const [paymentResult, setPaymentResult] = useState<paymentResult>({
    status: "success",
    message: "결제가 완료되었습니다.",
    paymentInfo: {
      paymentId: "1",
      paymentDate: "2022-01-01",
      paymentAmount: 10000,
      paymentStatus: PaymentType.PAID,
      paymentTitle: "상품명",
      paymentDescription: "상품 설명",
      paymentEtc: "기타 정보",
      paymentThumbnailUrl: "https://via.placeholder.com/150",
      paymentStoreName: "상점명",
      paymentStoreBadge: "상점 뱃지"
    }
  });

  //약관동의
  const [termsAgreement, setTermsAgreement] = useState({
    privacy: false,
    thirdParty: false,
    paymentService: false,
    doorPassword: false,
  });

  //결제수단
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(PaymentMethod.BILLING_KEY);
  const [cardList, setCardList] = useState<cardInfo[]>([]);
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [hasOrderInfo, setHasOrderInfo] = useState(false);

  const [orderProductInfo, setOrderProductInfo] = useState<orderProductInfo[]>([{
    orderProductId: '1',
    orderProductDate: '2025-11-20',
    orderProductAmount: 89500,
    orderProductStoreName: '앱코 온라인 스토어',
    orderProductStoreBadge: '공식',
    orderProductTitle: '앱코 AS104 유무선 블루투스 게이밍 기계식 키보드 N 화이트, 조약돌 슈팅 스타축',
    orderProductDescription: '1개 / 화이트 / 풀배열 / 조약돌 슈팅 스타축 / 키압 45g 균등 / 키캡 PBT재질 외 1건 / 유무선겸용',
    orderProductThumbnailUrl: 'https://picsum.photos/800/600?random=1',
  }]);

  // 결제 정보
  const [payAmountInfo, setPayAmountInfo] = useState({
    totalAmountAfterDiscount: 0,
    vatAfterDiscount: 0,
    deliveryFeeTotal: 0,
    finalAmount: 0,
    finalVat: 0,
  });

  //결제 결과 데이터
  const [paymentRequestResult, setPaymentRequestResult] = useState<PaymentRequestResult>({
    status: "",
    message: "",
    data: {}
  });

  const [resultMessage, setResultMessage] = useState<{
    type: 'ZENPAY_SUCCESS' | 'ZENPAY_FAILURE' | 'ZENPAY_CANCEL',
    error?: string,
    data?: {},
  }>({
    type: 'ZENPAY_CANCEL',
    error: '',
    data: {},
  });

  // 플랫폼 사이즈 변경 감지
  useEffect(() => {
    // 초기 사이즈 설정 
    setPlatform(getPlatform(window.innerWidth));
    // 윈도우 리사이즈 이벤트 핸들러
    const handleResize = () => {
      setPlatform(getPlatform(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setActiveCardIndex(prev => {
      const total = cardList.length + 1; // register 카드 포함
      if (total === 0) {
        return 0;
      }
      return Math.min(prev, total - 1);
    });
  }, [cardList.length]);

  useEffect(() => {
    const handleResize = () => {
      const body = document.body;
      body.setAttribute('data-theme-typography', 'KR');
      body.setAttribute('data-theme', 'light');

      if (window.innerWidth <= 375) {
        body.setAttribute('data-theme-grid', 'mobile');
      } else if (window.innerWidth <= 768) {
        body.setAttribute('data-theme-grid', 'tablet-vertical');
      } else {
        body.setAttribute('data-theme-grid', 'web');
      }
    };

    // 초기 실행
    handleResize();

    // resize 이벤트 리스너 등록
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // ZenPay 데이터 수신
  useEffect(() => {
    // 컴포넌트가 마운트되면 부모 창에 준비 완료 신호 보내기
    if (window.opener) {
      window.opener.postMessage({ type: 'ZENPAY_READY' }, '*');
    } else {
      window.location.href = '/';
      return;
    }

    const handleMessage = async (event: MessageEvent) => {
      const { type, requestInfo } = event.data;

      if (type === 'ZENPAY_INIT') {
        setRequestInfo(requestInfo);

        const accessToken = requestInfo.accessToken;
        let userInfo;
        try {
          userInfo = await axios.get(OAUTH + "/userinfo", {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
        } catch (error) {
          userInfo = null;
        }




        //결제 수단 셋팅
        if (userInfo != null && userInfo.data.email == requestInfo.customer.email) {
          setUserId(requestInfo.customer.email);
          await getBillingCard(requestInfo.customer.email);
          requestInfo.customer['fullName'] = userInfo.data.name;
          requestInfo.customer['phoneNumber'] = userInfo.data.phone_number;
        } else {
          //일치하지 않는경우 에러 모달 이후 페이지 닫음
          setStep("PAYMENT-RESULT");
          setPaymentResult({
            status: "fail",
            message: "사용자 정보가 올바르지 않습니다. 다시 시도해주세요.",
          });
          setResultMessage({
            type: 'ZENPAY_FAILURE',
            error: "사용자 정보가 올바르지 않습니다. 다시 시도해주세요.",
          });
          return;
        }

        // 결제 상세정보 할인정보 셋팅
        const discountInfo = paymentInfoSetting(requestInfo);

        //정기 결제 안내 셋팅
        subscriptionInfoSetting(requestInfo);

        //주문 상품 정보 셋팅
        orderProductInfoSetting(requestInfo);

        //배송 정보 확인
        //orderList를 순회 하면서 orderInfor가 있는지 확인
        let hasOrderInfo = false;
        requestInfo.orderList.forEach((order: any) => {
          if (order.orderInfo && Object.keys(order.orderInfo).length > 0) {
            hasOrderInfo = true;
          }
        });

        setHasOrderInfo(hasOrderInfo);

        payAmountInfoSetting(requestInfo, discountInfo);
      }
    };



    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // 주문 상품 정보 셋팅
  const orderProductInfoSetting = (requestInfo: any) => {
    const { orderList } = requestInfo;
    if (!orderList) return;


    const orderProductList: orderProductInfo[] = Array.isArray(orderList)
      ? orderList.flatMap((order: any) => {
        const marketName = order.marketName;
        const StoreBadge = order.StoreBadge || "공식";
        const orderInfo = order.orderInfo;
        const marketplaceInfo = order.marketplaceInfo;

        if (!Array.isArray(marketplaceInfo)) {
          return [];
        }

        return marketplaceInfo.map((item: any) => {
          const description = `${item.quanity}개 / ` + (Array.isArray(item.option)
            ? item.option.map((opt: any) => opt.optionName + " " + opt.optionValue).join(' / ')
            : ''); // 옵션이 배열이 아닐 경우를 대비

          let amount = item.price;

          return {
            // 주문 공통 정보
            orderProductId: item.marketplaceId,
            orderProductStoreName: marketName,
            orderProductStoreBadge: StoreBadge,

            // === 상품 개별 정보 ===
            orderProductTitle: item.item_name,
            orderProductThumbnailUrl: item.imageUrl ? item.imageUrl : undefined,
            orderProductAmount: amount, // 상품 개당 가격
            orderProductDescription: description, // 가공된 옵션 정보
          };
        });
      })
      : []; // orders가 배열이 아니면 최종 결과는 빈 배열 []이 됩니다.

    setOrderProductInfo(orderProductList);
  };

  // 결제 수단 가져오기
  const getBillingCard = async (userId: string) => {
    try {
      const url = ZENPAY_BILLING + "/all";
      const conditions = [
        { field: "userId", operator: "EQUALS", value: userId }
      ];
      const params = {
        page: 0,
        size: 0,
        sortField: ['createdDate'],
        sortOrder: ['asc'],
        operator: "AND",
        conditions
      };

      const res = await axios.post(url, params);
      const favoriteCard = await axios.get(`${ZENPAY_BILLING}/get/favorite-card`, { params: { userId: userId } });

      const { data } = res.data.data;
      const favoriteCardData = favoriteCard.data.data;
      const apiCardDataList: ApiCardData[] = data;

      // API 데이터를 cardInfo[] 형태로 변환
      const transformedCardList: cardInfo[] = apiCardDataList.map((apiCard) => {

        const cardBankType = mapApiIssuerToBankType(apiCard.issuer, apiCard.statementFactorName);
        const cardBrand = mapApiBrandToCardType(apiCard.brand);

        const cardName = getCardBankName(cardBankType); // ex: "신한카드"
        // 제공된 라이브러리 헬퍼 함수들을 사용
        const status = apiCard.billingKey === favoriteCardData.billingKeyId ? 'active' : 'inactive';

        return {
          id: String(apiCard.id),
          cardNumber: apiCard.cardNumber,
          cardType: apiCard.cardType == "체크" ? "Check" : "",
          cardBrand: cardBrand,
          cardBankType: cardBankType,
          cardName: apiCard.cardName || '기타 카드', // getCardBankName이 빈 문자열을 반환할 경우 대비
          cardBrandName: `${cardName || '기타'} ${cardBrand === CardType.DEFAULT ? '카드' : cardBrand}`, // 예시 로직
          billingKey: apiCard.billingKey,
          status: status,
        };
      });

      //카드 정렬 순서가 대표 카드가 앞에 오도록 정렬
      transformedCardList.sort((a, b) => {
        if (a.status === 'active' && b.status !== 'active') return -1;
        if (a.status !== 'active' && b.status === 'active') return 1;
        return 0;
      });

      setCardList(transformedCardList);
    } catch (error) {
      console.error(error);
    }
  };

  // 결제 상세정보 할인정보 셋팅
  const paymentInfoSetting = (requestInfo: any): DiscountInfo => {

    //여기서 orderList를 순회 하면서 가능?
    let totalDiscountAmount = 0;
    const discountDetails: { discountAmount: number, discountName: string }[] = [];

    // 모든 주문과 상품을 다시 순회하며 가격 및 할인 정보 집계
    if (Array.isArray(requestInfo.orderList)) {
      requestInfo.orderList.forEach((order: any) => {
        if (Array.isArray(order.marketplaceInfo)) {
          order.marketplaceInfo.forEach((item: any) => {
            // 할인 정보가 있는 경우에만 처리 (discountAmount가 0보다 클 때)
            item.discount.forEach((discount: any) => {
              const discountAmount = Number(discount.discountAmount || 0);
              if (discountAmount > 0) {
                // 총 할인 금액 합산
                totalDiscountAmount += discountAmount;
                // 상세 할인 내역 배열에 추가
                discountDetails.push({
                  discountAmount: discountAmount,
                  discountName: discount.discountName || '-알 수 없는 할인-'
                });
              }
            })
          });
        }
      });
    }


    // 4. 최종 할인율 계산 (0으로 나누는 오류 방지)
    const discountRate = requestInfo.totalAmount > 0
      ? Math.round((totalDiscountAmount / requestInfo.totalAmount) * 100)
      : 0;

    // 5. 요구사항에 맞는 최종 JSON 객체 생성
    const discountInfoJson = {
      discountRate: discountRate,
      discountAmount: totalDiscountAmount,
      value: discountDetails
    };
    setDiscount(discountInfoJson);

    return discountInfoJson;
  }

  // 정기 결제 정보 설정
  const subscriptionInfoSetting = (requestInfo: any) => {
    const { paymentInfo } = requestInfo.orderList[0];
    if (!paymentInfo) return;

    const { price_type, billingInterval, billingIntervalCount, billingDayOfMonth } = paymentInfo;

    // 다음 결제일 계산 (오늘 기준)
    const now = Date.now();
    const nextBillingTimestamp = calculateNextBillingTimestamp(
      now,
      price_type,
      billingInterval,
      billingIntervalCount,
      billingDayOfMonth || 0
    );

    const nextBillingDate = new Date(nextBillingTimestamp);
    const formattedNextDate = format(nextBillingDate, 'yyyy.MM.dd');

    // 결제 주기 포맷팅
    let formattedCycle = formatBillingPeriod(billingInterval, billingIntervalCount);

    // 상세 날짜 추가
    if (billingInterval === 'MONTH') {
      const day = nextBillingDate.getDate();
      formattedCycle = `${formattedCycle} ${day}일`;
    } else if (billingInterval === 'YEAR') {
      const month = nextBillingDate.getMonth() + 1;
      const day = nextBillingDate.getDate();
      formattedCycle = `${formattedCycle} ${month}월 ${day}일`;
    } else if (billingInterval === 'WEEK') {
      const dayOfWeek = nextBillingDate.toLocaleDateString('ko-KR', { weekday: 'long' });
      formattedCycle = `${formattedCycle} ${dayOfWeek}`;
    }

    setSubscriptionInfo({
      nextPaymentDate: formattedNextDate,
      paymentPeriod: formattedCycle,
    });
  }

  // 결제 금액 셋팅
  const payAmountInfoSetting = (requestInfo: any, discount: DiscountInfo) => {

    // requestInfo  totalAmount는 총 상품 결제 금액 할인 적용 x 부가세포함 금액
    // requestInfo  vat 총 상품 결제 금액 할인 적용 x 부가세포함 금액
    const totalAmount = requestInfo.totalAmount;
    const vat = requestInfo.vat;


    //결제 상세 정보에 금액, 부가세는 할인이 다 적용된 금액으로 표시
    // 부가세는 최종할인 적용 금액에서 /1.1 하고 나머지 숫자는 무조건 올린 절대값에서 뺀금액
    const totalAmountAfterDiscount = totalAmount - discount.discountAmount;
    const vatAfterDiscount = totalAmountAfterDiscount - Math.ceil(totalAmountAfterDiscount / 1.1);


    // 이제 최종 상품 금액은 끝낫는데 배송비가 포함된 마지막 최최종 금액이 필요해
    // 각 orderList를 돌면서 order에서 deliveryFee를 다 더한 배송비 총합
    let deliveryFeeTotal = 0;
    hasOrderInfo && requestInfo.orderList.forEach((order: any) => {
      deliveryFeeTotal += Number(order.orderInfo.deliveryFee);
    });

    // 최종 결제 금액은 
    const finalAmount = totalAmountAfterDiscount + deliveryFeeTotal;
    const finalVat = finalAmount - Math.ceil(finalAmount / 1.1);

    setPayAmountInfo({
      totalAmountAfterDiscount,
      vatAfterDiscount,
      deliveryFeeTotal,
      finalAmount,
      finalVat,
    });
  }


  // 전체 동의 여부 확인
  const isAllAgreed = hasOrderInfo
    ? termsAgreement.privacy && termsAgreement.thirdParty && termsAgreement.paymentService && termsAgreement.doorPassword
    : termsAgreement.privacy && termsAgreement.thirdParty && termsAgreement.paymentService;

  // 전체 동의 토글
  const handleAllAgree = (e: boolean) => {
    const checked = e;
    const hasOrderInfo = requestInfo.orderInfo && Object.keys(requestInfo.orderInfo).length > 0;

    setTermsAgreement({
      privacy: checked,
      thirdParty: checked,
      paymentService: checked,
      doorPassword: hasOrderInfo ? checked : false, // 배송 정보가 있을 때만 체크
    });
  };

  // 개별 약관 토글
  const handleTermToggle = (term: keyof typeof termsAgreement) => {
    setTermsAgreement(prev => ({
      ...prev,
      [term]: !prev[term]
    }));
  };

  // Order Request JSON 생성
  const createOrderRequest = (orderData: any): OrderRequest => {
    const { orderList } = requestInfo;

    // 구독상품일 경우 한개의 order만 들어오게 일단 로직 정의
    // 일반 상품일 경우 각 order(=market) 마다 order가 있을것 같음
    const order = orderList[0]; // 첫 번째 주문 (여러 개일 경우 수정 필요)

    return {
      customerId: requestInfo.customer.customerId,
      targetId: requestInfo.customer.targetId || "",
      sellerId: order.sellerId || "",
      paymentId: "",
      marketplaceId: order.marketplaceInfo[0].marketplaceId,
      orderStatus: PaymentType.PENDING,
      priceType: order.priceType,
      price: String(payAmountInfo.finalAmount - payAmountInfo.finalVat),
      taxPrice: String(payAmountInfo.finalVat),
      totalPrice: String(payAmountInfo.finalAmount),
      orderInfo: order.orderInfo || {},
      marketplaceInfo: order.marketplaceInfo,
      currency: "KRW"
    };
  };

  // Payment Request JSON 생성
  const createPaymentRequest = (orderId: string, billingKey: string): PaymentRequest => {
    const { orderList, customer } = requestInfo;
    const order = orderList[0]; // 첫 번째 주문
    const marketplace = order.marketplaceInfo[0];

    return {
      billingKey: billingKey,
      priceType: order.priceType,
      payMethod: paymentMethod,
      marketplaceId: marketplace.marketplaceId,
      marketName: order.marketName,
      orderId: orderId,
      orderName: order.orderName,
      customer: {
        customerId: customer.customerId,
        fullName: customer.fullName || "",
        email: customer.email,
        phoneNumber: customer.phoneNumber || ""
      },
      products: order.marketplaceInfo.map((item: any) => ({
        id: item.marketplaceId,
        name: item.item_name,
        amount: Number(item.price),
        quantity: Number(item.quanity),
        link: "",
        imageUrl: item.imageUrl,
        option: item.option,
        productModelType: item.productModelType
      })),
      totalAmount: payAmountInfo.finalAmount,
      paymentRequestDate: Date.now(),
      paymentInfo: order.paymentInfo
    };
  };

  // 결제 상태 확인 함수 (폴링 방식)
  const checkPaymentStatus = async (paymentId: string, maxAttempts: number = 30, intervalMs: number = 2000): Promise<any> => {
    let attempts = 0;

    while (attempts < maxAttempts) {
      try {
        const paymentStatus = await axios.get(`${ZENPAY_PAYMENT}/get/${paymentId}/status`, {
          headers: {
            'API-KEY': `zenta_store`,
          },
        });

        const requestResult = paymentStatus.data.data.requestResult;
        const requestResultDetail = paymentStatus.data.data.requestResultDetail;

        // SUCCESS 또는 FAILED 상태가 되면 결과 반환
        if (requestResult === "SUCCESS" || requestResult === "FAILED") {
          return {
            result: requestResult,
            detail: requestResultDetail,
            fullData: paymentStatus.data.data
          };
        }

        // PENDING 상태면 대기 후 재시도
        attempts++;

        if (attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, intervalMs));
        }
      } catch (error) {
        console.error('결제 상태 확인 중 오류:', error);
        throw error;
      }
    }

    // 최대 시도 횟수 초과 시 타임아웃 에러
    throw new Error('결제 상태 확인 시간이 초과되었습니다.');
  };

  const handleConfirm = () => {
    // 모든 필수 약관에 동의하지 않은 경우
    if (!isAllAgreed) {
      showDialog({
        type: 'info',
        iconType: 'info',
        title: '약관 동의 필요',
        message: '모든 필수 약관에 동의해주세요.',
        confirmText: '확인',
      });
      return;
    }

    if (activeItem.type === 'register') {
      showDialog({
        type: 'info',
        iconType: 'info',
        title: '카드 선택',
        message: '카드를 선택해주세요.',
        confirmText: '확인',
      });
      return;
    }

    handleOpenModal({
      selectMode: 'verify',
      userId: userId || requestInfo?.customer?.email,
      onSuccess: async () => {
        setIsLoading(true);
        try {
          // 1. Order Request 생성
          const orderRequest = createOrderRequest(requestInfo);
          console.log('Order Request:', orderRequest);

          // TODO: Order 생성 API 호출
          const orderResponse = await axios.post(`${STORE_ORDER}/create`, orderRequest, {
            headers: {
              'Content-Type': 'application/json'
            }
          });

          const orderId = orderResponse.data.message;

          // 2. Payment Request 생성
          const activeBillingKey = activeItem?.type === 'card' ? activeItem.data.billingKey || '' : '';
          const paymentRequest = createPaymentRequest(orderId, activeBillingKey);
          console.log('Payment Request:', paymentRequest);

          // Payment 생성 API 호출
          const paymentResponse = await axios.post(`${ZENPAY_PAYMENT}/request`, paymentRequest, {
            headers: {
              'Content-Type': 'application/json',
              'API-KEY': `zenta_store`,
            },
          });
          // const paymentId = "temp-payment-id-" + Date.now();
          const paymentId = paymentResponse.data.data.paymentId;
          console.log('Payment Response:', paymentResponse);

          // 4. 결제 상태 확인 (폴링)
          const paymentStatusResult = await checkPaymentStatus(paymentId);
          console.log('Payment Status Result:', paymentStatusResult);

          setPaymentRequestResult({
            status: paymentStatusResult.result,
            message: paymentStatusResult.result === "SUCCESS" ? "결제가 완료되었습니다." : "결제가 실패했습니다.",
            data: {
              paymentId: paymentId,
              orderData: orderRequest,
              paymentData: paymentRequest,
              paymentStatus: paymentStatusResult.detail,
              discount: discount,
              requestInfo: requestInfo,
              activeItem: activeItem,
            }
          });

          if (paymentStatusResult.result === "SUCCESS") {
            // Order 상태를 PAID로 업데이트
            const orderUpdateResponse = await axios.put(`${STORE_ORDER}/${orderId}/payment-id`,
              { paymentId: paymentId, orderStatus: PaymentType.PAID });
            console.log('Order Update Response:', orderUpdateResponse);

            // 5. 결제 완료 처리
            setIsLoading(false);
            setStep("PAYMENT-RESULT");
            setPaymentResult({
              status: "success",
              message: "결제가 완료되었습니다.",
            });
            setResultMessage({
              type: 'ZENPAY_SUCCESS',
              data: {
                paymentId: paymentId,
                orderId: orderId,
                subscriptionId: paymentResponse.data.data.subscriptionId || "",
              },
            });
          } else if (paymentStatusResult.result === "FAILED") {
            // Order 상태를 FAILED로 업데이트
            const orderUpdateResponse = await axios.put(`${STORE_ORDER}/${orderId}/payment-id`,
              { paymentId: paymentId, orderStatus: PaymentType.FAILED });
            console.log('Order Update Response:', orderUpdateResponse);

            setIsLoading(false);
            setStep("PAYMENT-RESULT");
            setPaymentResult({
              status: "fail",
              message: paymentStatusResult.detail || "결제가 실패했습니다.",
            });
            setResultMessage({
              type: 'ZENPAY_FAILURE',
              error: "결제 처리 중 오류가 발생했습니다.",
            });

          }

        } catch (error) {
          console.error('결제 처리 중 오류:', error);
          setIsLoading(false);
          showDialog({
            type: 'error',
            iconType: 'warning',
            title: '결제 실패',
            message: '결제 처리 중 오류가 발생했습니다.',
            confirmText: '확인',
          });
          setResultMessage({
            type: 'ZENPAY_FAILURE',
            error: "결제 처리 중 오류가 발생했습니다.",
          });
        }
      }
    });
  }


  // 결제 수단 카드 이름 변경 모달
  const handleModifyCard = (currentCard: cardInfo) => {
    showDialog({
      title: '템플릿 제목',
      message: '수정할 템플릿 제목을 입력해주세요.',
      enableActionFields: false,
      customContent: (closeDialog) => (
        <EditTitleForm
          initialTitle={currentCard.cardName || ''}
          onSave={async (value) => {
            closeDialog();
            const params = {
              userId: requestInfo.customer.customerId,
              cardName: value,
              billingKey: currentCard.billingKey,
            };

            const res = await axios.post(`${ZENPAY_BILLING}/update/billingName`, params);
            if (res.data.code === 200) {
              showDialog({
                type: 'info',
                iconType: 'check',
                title: '카드명 변경이\n완료되었습니다.',
                confirmText: '완료',
                onConfirm: () => {
                  setCardList(cardList.map((card: cardInfo) => currentCard.id === card.id ? { ...card, cardName: value } : card));
                }
              })
            } else {
              showDialog({
                type: 'error',
                iconType: 'warning',
                title: '카드명 변경이\n완료되지 않았습니다.\n다시 시도해주세요.',
                confirmText: '오류',
                onConfirm: () => {
                }
              })
            }
          }}
          onClose={closeDialog}
        />
      )
    });
  }

  const cardCarouselItems = [
    ...cardList.map(card => ({ type: 'card', data: card } as const)),
    { type: 'register' as const }
  ];

  const totalCards = cardCarouselItems.length;

  const handlePrevCard = () => {
    setActiveCardIndex(prev => (prev - 1 + totalCards) % totalCards);
  };

  const handleNextCard = () => {
    setActiveCardIndex(prev => (prev + 1) % totalCards);
  };

  const activeItem = cardCarouselItems[activeCardIndex];



  const handleRegisterCardSelect = async () => {

    const res = await axios.get(`${IAM_PATH}/status/authinfo/${requestInfo.customer.email}`, {
      headers: {
        Authorization: `Bearer ${requestInfo.accessToken}`,
      },
    });

    if (res.data.data === true) {
      showBottomModal({
        enableDefaultStyle: true,
        headerBuilder: () => { return <></>; },
        contentBuilder: (
          _data: any,
          _handleSave: any,
          _handleDelete: any,
          _handleUpdate: any,
          handleClose: any,
          _modalType: any
        ) => {
          return <RegisterCardModal
            isOpen={true}
            onClose={handleClose}
            onConfirm={async (data: any) => {
              handleClose();
              if (data.code === 401) {
                showDialog({
                  type: 'info',
                  iconType: 'warning',
                  title: '이미 등록된 카드입니다.',
                  confirmText: '확인',
                  onConfirm: () => { }
                })
                return;
              } else if (data.code === 502) {
                showDialog({
                  type: 'info',
                  iconType: 'warning',
                  title: '카드 정보가 일치하지 않습니다.',
                  confirmText: '확인',
                  onConfirm: () => { }
                })
                return;
              } else if (data.code === 200) {
                const response = await axios.get(`${ZENPAY_PAY_PASSWORD}/status/${getCookie('user_id')}`);
                const notHavePaymentPassword = response.data.data;
                // 페이 비밀번호 체크
                if (!notHavePaymentPassword) {
                  showDialog({
                    type: 'info',
                    iconType: 'info',
                    title: '페이 비밀번호를\n생성해주세요.',
                    message: '페이 비밀번호를 생성 후\n젠트리페이 결제를 이용하실 수 있습니다.',
                    confirmText: '페이 비밀번호 설정',
                    onConfirm: () => {

                      handleOpenModal({
                        selectMode: 'create',
                        onSuccess: () => { getBillingCard(requestInfo.customer.customerId); }
                      });
                    }
                  })
                } else {
                  showDialog({
                    type: 'info',
                    iconType: 'check',
                    title: '카드 등록이\n완료되었습니다.',
                    confirmText: '완료',
                    onConfirm: () => { getBillingCard(requestInfo.customer.customerId); }
                  })
                }
              } else {
                showDialog({
                  type: 'info',
                  iconType: 'warning',
                  title: '카드 등록에 실패했습니다.',
                  confirmText: '확인',
                  onConfirm: () => { }
                })
              }
            }}
          />;
        },
      });
    } else {
      showDialog({
        type: 'info',
        iconType: 'check',
        title: '본인 인증을 먼저 진행해주세요.',
        confirmText: '본인 인증',
        onConfirm: () => {
          //본인인증페이지로 이동
        }
      })
    }
  }

  const handleComplete = () => {
    //부모창으로 메시지 전달
    // 부모창으로 결제 완료 메시지 전달
    if (window.opener) {
      window.opener.postMessage(
        {
          type: resultMessage.type, // 'ZENPAY_SUCCESS'
          data: resultMessage.data,
          error: resultMessage.error
        },
        '*' // 프로덕션에서는 특정 origin으로 제한해야 합니다
      );

      // 메시지 전송 후 창 닫기
      window.close();
    } else {
      // opener가 없는 경우 (직접 접근한 경우)
      window.location.href = '/';
    }
    setStep("PAYMENT");
  }

  const handleFirstStep = () => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: resultMessage.type, // 'ZENPAY_SUCCESS'
          data: resultMessage.data,
          error: resultMessage.error
        },
        '*' // 프로덕션에서는 특정 origin으로 제한해야 합니다
      );

      // 메시지 전송 후 창 닫기
      window.close();
    } else {
      // opener가 없는 경우 (직접 접근한 경우)
      window.location.href = '/';
    }
    setStep("PAYMENT");
  }

  // 주문 상품 정보 위젯
  const orderInfoWidget = () => {
    return <div className={`${styles.orderInfoWrapper} ${styles.boxWrapper}`}>
      <h3 className="innocode-typography--bold innocode-typography--headline-xs">주문상품</h3>
      {orderProductInfo.map((orderProductInfo, index) => (
        <InnocodePaymentListHorizental
          key={orderProductInfo.orderProductId}
          className="list_item"
          size={"md"}
          status="default"
          showTopContents={false}
          leadingThumbnail={true}
          thumbnailSrc={orderProductInfo.orderProductThumbnailUrl || 'https://picsum.photos/800/600'}
          thumbnailAlt="썸네일 이미지"
          showThumbnailBadge={false}
          thumbnailBadgeLabel={"30%"}
          thumbnailSize={"sm"}
          showStoreInfo={true}
          showStoreName={true}
          storeName={orderProductInfo.orderProductStoreName || ''}
          showStoreBadge={true}
          storeBadgeStyle={"opacity"}
          storeBadgeLabel={orderProductInfo.orderProductStoreBadge || ''}
          showTitle={true}
          title={orderProductInfo.orderProductTitle || ''}
          showDescription={true}
          description={orderProductInfo.orderProductDescription || ''}
          showBottomContents={true}
          showAmount={true}
          amount={orderProductInfo.orderProductAmount}
          showPaymentDate={false}
          paymentDate={`${orderProductInfo.orderProductDate} 결제`}
          showButton={false}
        />
      ))}
    </div>;
  }

  // 결제 수단 위젯
  const payMethodInfoWidget = () => {
    if (platform === "web") {
      return <div className={`${styles.payMethodInfoWrapper} ${styles.boxWrapper}`}>
        <h3 className="innocode-typography--bold innocode-typography--headline-xs">결제 수단</h3>
        <div className={styles.cardListWrapper}>
          <button type="button" className="left-handler" onClick={handlePrevCard} aria-label="이전 카드">
            <svg className="w-6 h-6 text-gray-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
            </svg>
          </button>
          <div className={styles.cardListContent}>
            {activeItem?.type === 'card' ? (
              <InnocodePaymentCardInfo
                className={styles.cardItem}
                key={activeItem.data.id}
                cardType={'card'}
                cardBankName={activeItem.data.cardBrandName}
                cardName={activeItem.data.cardName}
                cardNumber={`${activeItem.data.cardNumber} ${activeItem.data.cardType}`}
                cardBankType={activeItem.data.cardBankType}
                size={'lg'}
                type="card"
                showBadge={activeItem.data.status === "active"}
                badge={{ children: "대표 카드" }}
                showModifyButton={true}
                onModify={() => { handleModifyCard(activeItem.data) }}
                showDeleteButton={false}
                status={"pressed"}
              />
            ) : (
              <InnocodePaymentCardInfo
                className={styles.cardItem}
                cardType={'register'}
                size={'lg'}
                type='register'
                cardName={"새 카드 등록"}
                showBadge={false}
                showDeleteButton={false}
                onClick={handleRegisterCardSelect}
              />
            )}
          </div>
          <button type="button" className="right-handler" onClick={handleNextCard} aria-label="다음 카드">
            <svg className="w-6 h-6 text-gray-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>;
    }

    return <div className={`${styles.payMethodInfoWrapper} ${styles.boxWrapper}`}>
      <h3 className="innocode-typography--bold innocode-typography--headline-xs">결제 수단</h3>
      <div className={styles.cardListWrapper}>
        <div className={`${styles.cardListContent} ${isExpanded ? styles.expanded : ''}`}>
          {/* 최대 4개만 표시 */}
          {cardList.map((item) => (
            <InnocodePaymentCardInfo
              className={styles.cardItem}
              key={item.id}
              cardType={'card'}
              cardBankName={item.cardBrandName}
              cardName={item.cardName}
              cardNumber={item.cardNumber}
              cardBankType={item.cardBankType}
              size={'sm'}
              type="card"
              showBadge={false}
              showModifyButton={true}
              onModify={() => { handleModifyCard(item) }}
              showDeleteButton={false}
            />
          ))}
          <InnocodePaymentCardInfo
            className={styles.cardItem}
            cardType={'register'}
            size={'sm'}
            type='register'
            cardName={"새 카드 등록"}
            showBadge={false}
            showDeleteButton={false}
            onClick={handleRegisterCardSelect}
          />

        </div>
        <InnocodeButton theme="solid" designType="assistive" size={"md"} className={styles.paymentMethodExpandedButton} onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? "접기" : "카드 전체보기"}</InnocodeButton>
      </div>
    </div>;
  }

  // 결제 금액 정보 위젯
  const payAmountInfoWidget = () => {
    return <div className={`${styles.payAmountInfoWrapper} ${styles.boxWrapper}`}>
      <div className={styles.payAmountInfoHeader}>
        <h3 className="innocode-typography--bold innocode-typography--headline-xs">결제 금액</h3>
        <p className={`${styles.payAmountInfoValue} innocode-typography--bold innocode-typography--headline-xs`}>{formatCurrency(payAmountInfo.finalAmount)}원</p>
      </div>
      <div className={styles.paymentInfoList}>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>상품 금액</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(payAmountInfo.totalAmountAfterDiscount)}원</p>
        </div>
        {/* order가 없을경우 배송이 없는 상품이므로 배송비가 없음
            만약 배송비가 무료인경우에는 orderInfo에 배송비가 0원
         */}
        {hasOrderInfo && (
          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>배송비</p>
            <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(payAmountInfo.deliveryFeeTotal)}원</p>
          </div>
        )}
      </div>
    </div>;
  }

  // 결제 상세 정보 위젯
  const paymentInfoWidget = () => {
    return <div className={`${styles.paymentInfoWrapper} ${styles.boxWrapper}`}>
      <h3 className="innocode-typography--bold innocode-typography--headline-xs">결제 상세 정보</h3>
      <div className={styles.paymentInfoList}>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>금액</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(requestInfo.totalAmount)}원</p>
        </div>
        {/* <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>부가세</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{payAmountInfo.vatAfterDiscount}원</p>
        </div> */}
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>할인</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>
            {discount.discountAmount > 0 ? `-${formatCurrency(discount.discountAmount)}원` : '0원'}
          </p>
        </div>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>최종금액</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(payAmountInfo.finalAmount)}원</p>
        </div>
      </div>
      <div className={styles.divider}></div>
      <h3 className="innocode-typography--bold innocode-typography--headline-xs">정기 결제 안내</h3>
      <div className={styles.paymentInfoList}>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>다음 결제일</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{subscriptionInfo.nextPaymentDate}</p>
        </div>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 주기</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{subscriptionInfo.paymentPeriod}</p>
        </div>
        <div className={styles.item}>
          <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 금액</p>
          <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(payAmountInfo.finalAmount)}원</p>
        </div>
      </div>
    </div>;
  }

  //약관 클릭 핸들러
  const handleTermClick = (type: string) => {
    if (type === "PRIVACY") {
      showBottomModal({
        enableDefaultStyle: true,
        enableMobileFullScreen: false,
        headerBuilder: () => { return <></>; },
        contentBuilder: (
          _data: any,
          _handleSave: any,
          _handleDelete: any,
          _handleUpdate: any,
          handleClose: any,
          _modalType: any
        ) => {
          const term = TERMS['PRIVACY'];
          return <TermModal
            {...term}
            isOpen={true}
            onClose={handleClose}

          />;
        },
      });
    } else if (type === "REFUND_GUIDE") {
      showBottomModal({
        enableDefaultStyle: true,
        enableMobileFullScreen: false,
        headerBuilder: () => { return <></>; },
        contentBuilder: (
          _data: any,
          _handleSave: any,
          _handleDelete: any,
          _handleUpdate: any,
          handleClose: any,
          _modalType: any
        ) => {
          const term = TERMS['REFUND_GUIDE'];
          return <TermModal
            {...term}
            isOpen={true}
            onClose={handleClose}

          />;
        },
      });
    } else {
      showBottomModal({
        enableDefaultStyle: true,
        enableMobileFullScreen: false,
        headerBuilder: () => { return <></>; },
        contentBuilder: (
          _data: any,
          _handleSave: any,
          _handleDelete: any,
          _handleUpdate: any,
          handleClose: any,
          _modalType: any
        ) => {
          const term = TERMS['REFUND_GUIDE'];
          return <TermModal
            title={"이용약관"}
            content='약관이 존재하지 않습니다.'
            isOpen={true}
            onClose={handleClose}

          />;
        },
      });
    }
  }

  //약관동의 위젯
  const termsInfoWidget = () => {
    return <div>
      <div className={`${styles.termsInfoWrapper} ${styles.boxWrapper}`}>
        <h3 className="innocode-typography--bold innocode-typography--headline-xs">주문 내용 확인 및 결제 동의</h3>
        <div className="terms-info-list">
          <InnocodeCheckbox leadingIcon={true} title="전체 동의" checked={isAllAgreed} onChange={(e) => handleAllAgree(e)} size="md"></InnocodeCheckbox>

          <div className={styles.rowItem}>
            <InnocodeCheckmark checked={termsAgreement.privacy} onChange={() => handleTermToggle('privacy')} size="md"></InnocodeCheckmark>
            <p className={`${styles.flexValue} innocode-typography--label-md innocode-typography--medium`}>(필수) 개인정보 수집 및 이용 동의</p>
            <svg onClick={() => handleTermClick("PRIVACY")} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
            </svg>

          </div>
          <div className={styles.rowItem}>
            <InnocodeCheckmark checked={termsAgreement.thirdParty} onChange={() => handleTermToggle('thirdParty')} size="md"></InnocodeCheckmark>
            <p className={`${styles.flexValue} innocode-typography--label-md innocode-typography--medium`}>(필수) 개인정보 제 3자 정보 제공 동의</p>
            <svg onClick={() => handleTermClick("NONE")} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
            </svg>
          </div>
          <div className={styles.rowItem}>
            <InnocodeCheckmark checked={termsAgreement.paymentService} onChange={() => handleTermToggle('paymentService')} size="md"></InnocodeCheckmark>
            <p className={`${styles.flexValue} innocode-typography--label-md innocode-typography--medium`}>(필수) 결제대행 서비스 이용약관 동의</p>
            <svg onClick={() => handleTermClick("NONE")} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
            </svg>
          </div>
          {/* 배송 정보가 있을때만 표시 */}
          {hasOrderInfo && (
            <div className={styles.rowItem}>
              <InnocodeCheckmark checked={termsAgreement.doorPassword} onChange={() => handleTermToggle('doorPassword')} size="md"></InnocodeCheckmark>
              <p className={`${styles.flexValue} innocode-typography--label-md innocode-typography--medium`}>(필수) 공동현관비밀번호 개인정보 수집 및 이용 동의</p>
              <svg onClick={() => handleTermClick("NONE")} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
              </svg>
            </div>
          )}
        </div>
      </div>
      <div className={styles.etcInfoWrapper}>
        <p className={`${styles.etcDescriptionText} innocode-typography--body-md-reading innocode-typography--regular page-description-text`}>
          개별 판매자가 등록한 상품에 대한 광고, 상품주문, 배송, 환불의 의무와<br />
          책임은 각 판매자에게 있으며, 개별 판매자의 상품에 대하여<br />
          젠타스토어는 통신판매중개자로서 통신판매의 당사자가 아닙니다.
        </p>
      </div>
    </div>;
  }





  return (
    <div className="innocode-breakpoint-layout-bg">
      <div className="innocode-breakpoint-content" >
        <div className="layout-container">
          {isLoading && <InnocodeLoadingSpinner message={'결제를 진행하고있습니다.\n잠시만 기다려주세요.'} />}
          {step === "PAYMENT" && (
            <div className={styles.pageWrapper}>

              <div className={styles.titleSection}>
                {platform === "web" && (
                  <InnocodeButton iconOnly={true} onClick={() => window.history.back()} designType='assistive' theme="opacity">
                    <svg {...{ slot: "icon" }} className="w-6 h-6 text-gray-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                    </svg>
                  </InnocodeButton>
                )}
              </div>
              <div className={styles.contentSection} >
                <h3 className="innocode-typography--headline-sm innocode-typography--bold">결제</h3>
                {platform === "web" ? (
                  <div className={styles.paymentWrapper}>
                    <div className={styles.paymentLeftWrapper}>
                      {orderInfoWidget()}
                      {paymentInfoWidget()}
                      {termsInfoWidget()}
                    </div>
                    <div className={styles.paymentRightWrapper}>
                      {payAmountInfoWidget()}
                      {payMethodInfoWidget()}
                      <div className={styles.payActionWrapper}>
                        <InnocodeButton size={"xl"} className={styles.paymentActionButton} onClick={handleConfirm}>결제하기</InnocodeButton>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={styles.paymentWrapper}>
                    {orderInfoWidget()}
                    {payMethodInfoWidget()}
                    {paymentInfoWidget()}
                    {payAmountInfoWidget()}
                    {termsInfoWidget()}
                    <div className={styles.payActionWrapper}>
                      <InnocodeButton size={"xl"} className={styles.paymentActionButton} onClick={handleConfirm}>결제하기</InnocodeButton>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {step === "PAYMENT-RESULT" && (
            paymentResult.status === "success" ? (
              <PaymentSuccessForm onConfirm={handleComplete} paymentResult={paymentRequestResult} />
            ) : (
              <PaymentFailForm onConfirm={handleFirstStep} paymentResult={paymentRequestResult} />
            )
          )}
        </div>
      </div>
    </div>
  );
}

const EditTitleForm: React.FC<{
  initialTitle: string;
  onSave: (title: string) => void;
  onClose: () => void;
}> = ({ initialTitle, onSave, onClose }) => {
  const [localTitle, setLocalTitle] = useState<string>(initialTitle);

  return (
    <div style={{ width: '100%', gap: '24px', display: 'flex', flexDirection: 'column' }}>
      <InnocodeInput
        value={localTitle || ''}
        maxLength={10}
        onChange={(e: any) => {
          const value = e.target.value;
          if (value.length <= 10) {
            setLocalTitle(value);
          }
        }}
        showTrailingContent={true}
        trailingContent={
          <span>{localTitle?.length || 0}/10</span>
        }
        autoFocus
      />
      <div style={{ display: 'flex', gap: '8px' }}>
        <InnocodeButton
          theme="line" designType="assistive" size="lg" style={{ width: '100%' }}
          onClick={() => {
            onClose();
          }}
        >
          취소
        </InnocodeButton>
        <InnocodeButton
          theme="solid" designType="primary" size="lg" style={{ width: '100%' }}
          onClick={() => {
            if (localTitle.trim() !== '') {
              onSave(localTitle);
            }
          }}
        >
          변경
        </InnocodeButton>
      </div>
    </div>
  );
};


// 결제 성공 시 화면
const PaymentSuccessForm: React.FC<{
  paymentResult: PaymentRequestResult;
  onConfirm: () => void;
}> = ({ paymentResult, onConfirm }) => {

  const handleConfirm = () => {
    onConfirm();
  }

  const formatCurrency = (amount: any): string => {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (numAmount || 0).toLocaleString('ko-KR');
  };

  let paymentType = 'ZENTAPAY';
  const paymentMethod = paymentResult.data.paymentData.payMethod;

  if (paymentMethod === PaymentMethod.BILLING_KEY) {
    paymentType = `ZenPAY(${paymentResult.data.activeItem.data.cardName})`;
  } else if (paymentMethod === PaymentMethod.CARD || paymentMethod === PaymentMethod.KEYIN) {
    paymentType = 'ZENTAPAY';
  } else if (paymentMethod === PaymentMethod.TRANSFER) {
    paymentType = 'ZENTAPAY';
  } else if (paymentMethod === PaymentMethod.VIRTUAL_ACCOUNT) {
    paymentType = 'ZENTAPAY';
  } else if (paymentMethod === PaymentMethod.MOBILE) {
    paymentType = '모바일';
  }

  const discount: DiscountInfo = paymentResult.data.discount;

  return (
    <div className={styles.paymentSuccessForm}>
      <div className={styles.paymentSuccessWrapper}>
        <div className={styles.paymentSuccessIcon}>
          <svg className="w-[48px] h-[48px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z" clip-rule="evenodd" />
          </svg>

        </div>
        <h3 className={`${styles.paymentSuccessTitle} innocode-typography--title-sm innocode-typography--bold`}>결제가 완료되었습니다.</h3>
        {paymentResult.data.paymentData.price_type !== 'ONE_TIME' &&
          <span className={styles.paymentSuccessDescription}>현재 이용중인 플랜의 종료시점 이후 결제한<br />새로운 플랜이 적용됩니다.</span>
        }
      </div>
      <div className={`${styles.paymentInformationWrapper} ${styles.boxWrapper}`} >
        <h3 className="innocode-typography--headline-md innocode-typography--bold">결제 상세 정보</h3>
        <div className={styles.paymentInformationItemList}>
          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>상품명</p>
            <div className={`${styles.valueWrapper} mobile-vertical`}>
              <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>{paymentResult.data.paymentData.orderName}</p>
              {/* <p className={`${styles.valueInWrapperShrink} innocode-typography--body-lg-normal innocode-typography--medium`}>외 2건</p> */}

            </div>
          </div>
          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 번호</p>
            <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{paymentResult.data.paymentId}</p>
          </div>
          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제일</p>
            <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{moment(paymentResult.data.paymentData.paidAt).format('YYYY.MM.DD HH:mm:ss') || ''}</p>
          </div>
          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>할인 금액</p>
            {/* <div className={styles.valueWrapper}>
              <InnocodeBadge theme="opacity" type="primary" size="lg" className="discount-badge">00% 할인</InnocodeBadge>
              <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>-30,000원</p>
            </div> */}
            {paymentResult.data.discount.discountRate > 0 ?
              <>
                <InnocodeBadge theme="opacity" type="primary" size="lg" className="discount-badge">{paymentResult.data.discount.discountRate}% 할인</InnocodeBadge>
                <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(paymentResult.data.discount.discountAmount)}원</p>
              </>
              : <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>0원</p>
            }
          </div>
          {discount.value.length > 0 &&
            discount.value.map((item, index) => (
              <div className={styles.item} key={index}>
                <p className={`${styles.label} innocode-typography--body-sm-reading innocode-typography--medium ${styles.discountInfo}`}>↳ {item.discountName}</p>
                <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{formatCurrency(item.discountAmount)}원</p>
              </div>
            ))
          }

          <div className={styles.item}>
            <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 수단</p>
            <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{paymentType}</p>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div>
          <p className="innocode-typography--headline-xs innocode-typography--semibold">총 결제 금액</p>
          <p className="innocode-typography--headline-sm innocode-typography--bold">{formatCurrency(paymentResult.data.orderData.totalPrice)}원</p>
        </div>
      </div>
      <div className={styles.paymentSuccessButtonWrapper}>
        <InnocodeButton theme="solid" designType="primary" size={"xl"} className={styles.paymentSuccessButton} onClick={handleConfirm}>홈으로</InnocodeButton>
      </div>
    </div>
  );
};

// 결제 실패 시 화면
const PaymentFailForm: React.FC<{
  paymentResult: PaymentRequestResult;
  onConfirm: () => void;
}> = ({ paymentResult, onConfirm }) => {

  const handleConfirm = () => {
    onConfirm();
  }

  return (
    <div className={styles.paymentFailForm}>
      <div className={styles.paymentFailWrapper}>
        <div className={styles.paymentFailIcon}>
          <svg className="w-[48px] h-[48px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z" clip-rule="evenodd" />
          </svg>

        </div>
        <h3 className="innocode-typography--title-sm innocode-typography--bold">결제를 실패했습니다.</h3>
        <span className={styles.paymentFailDescription}>알수없는 오류가 발생했습니다.<br />잠시 후 다시 시도해주세요.</span>
      </div>
      <div className={styles.paymentFailButtonWrapper}>
        <InnocodeButton theme="solid" designType="assistive" size={"xl"} className={styles.paymentFailButton} onClick={handleConfirm}>확인</InnocodeButton>
      </div>
    </div>
  );
};